/* eslint-disable */

import React, { useState } from "react";

import cross from "assets/images/adduser/cross.svg";
import crossDark from "assets/images/adduser/crossDark.svg";
import list from "assets/images/dropdown/chevronleft.svg";
import downArrow from "assets/images/dropdown/downArrowDark.svg";
import successpic from "assets/images/uploadfiles/uploadSuccess.svg";
import "./uploaddropdown.scss";
import { files } from "constants/filesListDD/files";
import useTheme from "hooks/observer";
import useScreenMobile from "hooks/useScreen";
import { formatFileSize } from "constants/Common/formatFileSize";
import { getFileIcon } from "containers/Homepage/Ysafe/UploadFileContent";
// import { getFileIcon } from "containers/Homepage/Ysafe/UploadFileContent";
// import { formatFileSize } from "constants/Common/formatFileSize";

const UploadDropDown = ({
  setUploadModal,
  setFilesList,
  setUploadedFiles,
  filesList,
  setCancelUploadModal,
  setShowLoadingProgress,
  cancelUploadModal,
  progress,
  selectedFile,
  timeRemaining,
  setSelectedFile
}) => {
  const filesCount = 3;
  // const [progress, setProgress] = useState(0);
  // const [timeLeft, setTimeLeft] = useState(3);
  const [showList, setShowList] = useState(true);
  

  const theme = useTheme();

  // useEffect(() => {
  //   if (progress === 100) {
  //     setTimeout(() => {
  //       setUploadModal(false);
  //       setUploadedFiles((pre) => {
  //         return [...pre, filesList];
  //       });
  //       setFilesList([]);
  //     }, 2000);
  //   }
  // }, [progress]);

  const isMobile = useScreenMobile({ size: 992 });

  // const cancelHandler = () => {
  //   setCancelUploadModal(true);
  //   setProgress(0);
  //   setFilesList([]);
  //   setUploadModal(false);
  // };

  return (
      <></>
  //   <div className="dropDownContainer">
  //     <div className="header">
  //       <p className="text">
  //         {progress !== 100
  //           ? `Uploading ${selectedFile ? "1" : filesCount} files`
  //           : "Upload Completed"}
  //       </p>
  //       <div className="icons">
  //         <img
  //           src={theme == "light" ? list : downArrow}
  //           alt="show/hide list"
  //           className={!showList && "hide"}
  //           onClick={() => {
  //             setShowList((pre) => !pre);
  //             if (isMobile) {
  //               setShowLoadingProgress(true);
  //               setUploadModal(false);
  //             }
  //           }}
  //         />
  //         <img
  //           src={theme == "light" ? cross : crossDark}
  //           alt="close"
  //           onClick={() => {
  //             setCancelUploadModal(true);
  //             setUploadModal(false);
  //             setSelectedFile([]);
  //           }}
  //         />
  //       </div>
  //     </div>

  //     <div className="progress">
  //       <div className="progressContainer">
  //         <div className="progressBar" style={{ width: `${progress}%` }} />
  //         <div className="progressText">{progress}%</div>
  //         {progress !== 100 && (
  //           <>
  //             <div className="dot"></div>
  //             <div className="timeLeft">
  //               {Math.floor(timeRemaining)}{" "}
  //               {Math.floor(timeRemaining) > 1 ? "secs" : "sec"} left
  //             </div>
  //           </>
  //         )}
  //       </div>
  //     </div>
  //     <div className={showList ? "files" : "hideFiles"}>
  //       {selectedFile?.map((file, index) => (
  //         <div className="file" key={index}>
  //           <div className="content">
  //             <img src={getFileIcon(selectedFile.type)} alt="file" />
  //             <div className="nameBytesWrapper">
  //               <p className="fileName">{file.name}</p>
  //               <p className="fileSize">{formatFileSize(file.size)}</p>
  //             </div>
  //           </div>
  //           <div className="success">
  //             {progress <= 50 && <img src={successpic} alt="state" />}
  //           </div>
  //         </div>
  //       ))}
  //       {/* {selectedFile && (
  //         <div className="file">
  //           <div className="content">
  //             <img src={getFileIcon(selectedFile.type)} alt="file" />
  //             <div className="nameBytesWrapper">
  //               <p className="fileName">{selectedFile.name}</p>
  //               <p className="fileSize">{formatFileSize(selectedFile.size)}</p>
  //             </div>
  //           </div>
  //           <div className="success">
  //             <img src={successpic} alt="state" />
  //           </div>
  //         </div>
  //       )} */}
  //     </div>
  //   </div>
  );
};

export default UploadDropDown;
